export enum EadStatuses {
  RECEIVED = "RECEIVED",
  DELETED = "DELETED",
  NOT_RECEIVED = "NOT_RECEIVED",
}
